import { IntlShape } from 'react-intl';
import type { PlayerMetaEpisode } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { presentTitle } from '@/shared/lib/movie';

export const getMetaSubTitle = (intl: IntlShape, meta: PlayerMetaEpisode) => {
    const { episodeNumber, seasonNumber, episodeTitle } = meta;

    if (seasonNumber === null) {
        return '';
    }

    const finalTitle = presentTitle(episodeTitle);

    return finalTitle
        ? intl.formatMessage(
              {
                  id: 'features.episode-player.b89d38382a22a4643605a234109a6a3a',
                  defaultMessage: 'Season {seasonNumber}, episode {seriesNumber}. {finalTitle}',
                  description: 'Мета для тв шоу c финальным заголовоком',
              },
              { seasonNumber, seriesNumber: episodeNumber, finalTitle }
          )
        : intl.formatMessage(
              {
                  id: 'features.episode-player.225d3005c7b03fb249de8912bb6810ae',
                  defaultMessage: 'Season {seasonNumber}, episode {seriesNumber}.',
                  description: 'Мета для тв шоу',
              },
              { seasonNumber, seriesNumber: episodeNumber }
          );
};
